import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Icon, Stack } from '@optimus-web/core';
import { WithOwnerId } from '@mews-commander/types';
import { useGetInfoAccount } from '../../../utils';

export const BillOwnerType = ({ ownerId }: WithOwnerId) => {
    const accountInfo = useGetInfoAccount({ accountId: ownerId });

    return (
        <Stack spacing="100" itemAlignment="center">
            {accountInfo.iconValue ? <Icon size="small" value={accountInfo.iconValue} /> : null}
            <LocalizedText textKey={accountInfo.isCompany ? TextKey.Company : TextKey.Customer} />
        </Stack>
    );
};
